// 前端 token 统一存取。
// 用独立 key 存到 localStorage，避开与后端下发的 HttpOnly 同名 Authorization Cookie 冲突，
// 保证刷新页面后前端仍能稳定读取到 token。
import Cookies from 'js-cookie';

const TOKEN_KEY = 'FRONT_AUTH_TOKEN';
const USER_NAME_KEY = 'FRONT_USER_NAME';

export function setAuthToken(token) {
    if (!token) return;
    localStorage.setItem(TOKEN_KEY, token);
}

export function getAuthToken() {
    // 优先 localStorage；兼容历史上存在 Cookie 里的情况
    return localStorage.getItem(TOKEN_KEY) || Cookies.get('Authorization') || '';
}

export function setAuthUserName(userName) {
    if (userName == null) return;
    localStorage.setItem(USER_NAME_KEY, userName);
}

export function getAuthUserName() {
    return localStorage.getItem(USER_NAME_KEY) || Cookies.get('user_name') || '';
}

export function clearAuth() {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_NAME_KEY);
    // 一并清理历史 Cookie
    Cookies.set('Authorization', '');
    Cookies.set('user_name', '');
}
